'use client';

import { useSearchParams, useRouter, usePathname } from 'next/navigation';

import { Text } from '@backyard-ui/core';
import { z } from 'zod';

import { Pagination } from '@/presenters/components/common/Pagination';
import { MapLinkList, MapTitle } from '@/presenters/components/site-map';
import { useGetProductsMap } from '@/presenters/hooks/site-map';

const validatePageParam = (value: string | null) =>
  z.coerce.number().int().gte(1).safeParse(value);

export default function ProductsMap() {
  const searchParams = useSearchParams();
  const { replace } = useRouter();
  const pathname = usePathname();

  const pageParam = searchParams.get('page');

  const queryPageValidation = validatePageParam(pageParam);

  const currentPage = queryPageValidation.success
    ? queryPageValidation.data
    : 1;

  if (!queryPageValidation.success) {
    replace(`${pathname}?page=1`);
  }

  const {
    data: productsMap,
    isFetching,
    isFetched,
  } = useGetProductsMap(currentPage);

  if (productsMap && productsMap.page > productsMap.pages) {
    replace(`${pathname}?page=1`);
  }

  if (isFetching || !isFetched) {
    return (
      <>
        <MapTitle>Mapa do Site - Produtos</MapTitle>

        <div className="mt-4 pl-6 text-center">
          <Text>Carregando...</Text>
        </div>
      </>
    );
  }

  if (!productsMap?.data.length) {
    return (
      <>
        <MapTitle>Mapa do Site - Produtos</MapTitle>

        <div className="mt-4 pl-6 text-center">
          <Text>Serviço indisponível</Text>
        </div>
      </>
    );
  }

  return (
    <>
      <MapTitle>Mapa do Site - Produtos</MapTitle>

      <MapLinkList items={productsMap.data} />

      <Pagination
        currentPage={productsMap.page}
        totalPages={productsMap.pages}
      />
    </>
  );
}
